import * as React from "react";
import { Check, ChevronDown, X } from "lucide-react";
import { cn } from "../../lib/utils";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/ui/popover";

const MultiSelect = ({
  options,
  selected,
  onChange,
  placeholder = "Select options...",
  className,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleSelect = (value) => {
    if (selected.includes(value)) {
      onChange(selected.filter((item) => item !== value));
    } else {
      onChange([...selected, value]);
    }
  };

  const handleRemove = (value, e) => {
    e.stopPropagation();
    onChange(selected.filter((item) => item !== value));
  };

  const selectedLabels = options.filter((option) =>
    selected.includes(option.value)
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn(
            "w-full justify-between h-auto min-h-10 bg-secondary/50 border-border hover:bg-secondary/80",
            className
          )}
        >
          <div className="flex flex-wrap gap-1">
            {selectedLabels.length > 0 ? (
              selectedLabels.map((option) => (
                <Badge
                  key={option.value}
                  variant="secondary"
                  className="bg-primary/20 text-primary border-primary/30 hover:bg-primary/30"
                >
                  {option.label}
                  <span
                    onClick={(e) => handleRemove(option.value, e)}
                    className="ml-1 hover:text-destructive cursor-pointer"
                  >
                    <X className="h-3 w-3" />
                  </span>
                </Badge>
              ))
            ) : (
              <span className="text-muted-foreground">{placeholder}</span>
            )}
          </div>
          <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>

      <PopoverContent className="w-full min-w-[300px] p-0 bg-popover border-border">
        <div className="max-h-60 overflow-auto p-1">
          {options.map((option) => (
            <div
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className={cn(
                "flex items-center gap-2 px-3 py-2 cursor-pointer rounded-md transition-colors",
                "hover:bg-secondary/80",
                selected.includes(option.value) && "bg-primary/10"
              )}
            >
              <div
                className={cn(
                  "flex h-4 w-4 items-center justify-center rounded border border-border",
                  selected.includes(option.value) &&
                    "bg-primary border-primary"
                )}
              >
                {selected.includes(option.value) && (
                  <Check className="h-3 w-3 text-primary-foreground" />
                )}
              </div>
              <span className="text-sm">{option.label}</span>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export { MultiSelect };
